/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/instantsearch.js/~/lodash/_freeGlobal.js
// module id = 356
// module chunks = 0